<template>
    <div class="container-fluid">
        <Breadcrumb title="Add SpamTrap Domain" v-bind:button-show="false" v-show="!$route.params.id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit SpamTrap Domain #' + $route.params.id" v-bind:button-show="false"
                    v-show="$route.params.id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-show="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">SpamTrap Domain info</h4>
                        <SpamDomainForm @hidePreloader="hidePreloader"></SpamDomainForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import SpamDomainForm from './forms/SpamDomainForm';

    export default {
        name: 'SpamDomain',
        components: {SpamDomainForm, Preloader, Breadcrumb},
        data() {
            return {
                loading: false
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.loading = true;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = !value
            }
        }
    }
</script>

<style scoped>

</style>